import {useTheme, Stack, FontIcon, Text, mergeStyles} from '@fluentui/react';
import {getListClassNames} from 'styles';
import {TFunction} from 'i18next';
import React from 'react';
import {getDashboardClassNames} from './Common/BaseWorkBenchComponent';

export const WorkbenchHeader = (props: any) => {
	const theme = useTheme();
	const classNames = getListClassNames(theme, props.halfHeight);

	let icon = <></>;
	if (props.filterIconCallback) {
		icon = (
			<Stack>
				<FontIcon
					iconName={props.anyFilterSet === true ? 'ClearFilter' : 'Filter'}
					className={mergeStyles(classNames.iconStyles, classNames.pointer)}
					onClick={props.filterIconCallback}
				/>
			</Stack>
		);
	} else if (props.hideNewWindowIcon !== true) {
		icon = (
			<Stack>
				<FontIcon
					iconName='OpenInNewWindow'
					className={classNames.iconStyles}
				/>
			</Stack>
		);
	}

	return (
		<Stack horizontal horizontalAlign='space-between'>
			<Stack horizontal>
				<Stack.Item>
					<Text className={classNames.workbench}>{props.title}</Text>
				</Stack.Item>
				{typeof props.items === 'number' && (
					<Stack.Item>
						<Text className={classNames.itemCount}>{props.items}</Text>
					</Stack.Item>
				)}
			</Stack>
			{icon}
		</Stack>
	);
};

export const NewsItemsHeader = (props: any) => {
	const theme = useTheme();
	const classNames = getListClassNames(theme, props.halfHeight);

	return (
		<div>
			<Stack horizontal horizontalAlign='space-between'>
				<Stack.Item>
					<Text className={classNames.activity}>{props.title}</Text>
				</Stack.Item>
				<Stack.Item>
					<FontIcon
						iconName='OpenInNewWindow'
						className={classNames.iconStyles}
					/>
				</Stack.Item>
			</Stack>
		</div>
	);
};

type headerProps = {
	t: TFunction;
	isVex?: boolean;
	isVko?: boolean;
	vkoKeywordCount?: number;
};

export const renderKeywordHeader = ({
	t,
	isVex = false,
	isVko = false,
	vkoKeywordCount = -1,
}: headerProps): JSX.Element | undefined => {
	if (isVex) {
		return <Text variant='large'>{t('AssignedKeywords') as string}</Text>;
	}

	if (isVko) {
		if (vkoKeywordCount === 0) {
			return (
				<Text variant='large'>{t('NoAssignedMainKeywords') as string}</Text>
			);
		}
		return <Text variant='large'>{t('AssignedMainKeywords') as string}</Text>;
	}

	return undefined;
};

export const renderVexClusterHeader = ({
	t,
	isVex = false,
}: headerProps): JSX.Element | undefined => {
	if (isVex) {
		return <Text variant='large'>{t('AssignedVexClusters') as string}</Text>;
	}
	return undefined;
};

export const renderRegulationsHeader = ({
	t,
	isVex = false,
}: headerProps): JSX.Element | undefined => {
	if (isVex) {
		return <Text variant='large'>{t('RegulationsInScope') as string}</Text>;
	}
	return undefined;
};

export const renderRequirementsHeader = ({
	t,
	isVex = false,
}: headerProps): JSX.Element | undefined => {
	if (isVex) {
		return <Text variant='large'>{t('RequirementsInScope') as string}</Text>;
	}
	return undefined;
};

export const RegulationHeaderRow: React.FC<{
	columnKey: string;
	proportionTable: number[];
	t: any;
}> = (props: {columnKey: string; proportionTable: number[]; t: any}) => {
	const theme = useTheme();
	const dashboardClassNames = getDashboardClassNames(theme);
	const headers = [] as JSX.Element[];
	let counter = 0;

	const addHeader = (content: any) => {
		headers.push(
			<div
				style={{
					backgroundColor: theme.palette.white,
					width: `${props.proportionTable[counter]}%`,
					padding: '6px 0 0 12px',
					textAlign: 'left',
				}}
			>
				<Text className={dashboardClassNames.regulatoryHeaderCell}>
					{content}
				</Text>
			</div>,
		);
		counter++;
	};

	addHeader(props.t('RegulationVersion'));
	addHeader(props.t('LegalArea'));
	// addHeader(props.t('Status'));
	addHeader(props.t('MyVexClusters'));

	if (props.columnKey !== props.t('CompletedTitle')) {
		addHeader(props.t('NoOfSegments'));
	}

	return (
		<div className={dashboardClassNames.regulatoryHeaderRowPadding0}>
			{headers}
		</div>
	);
};

export const BaseLineHeaderRow: React.FC<{
	t: any;
}> = (props: {t: any}) => {
	const theme = useTheme();
	const dashboardClassNames = getDashboardClassNames(theme);

	const headers = [];

	headers.push(
		<Text className={dashboardClassNames.baseLineHeaderCell}>
			{props.t('BaselineName')}
		</Text>,
	);

	headers.push(
		<Text className={dashboardClassNames.baseLineHeaderCell}>
			{props.t('CreationDate')}
		</Text>,
	);

	return (
		<div className={dashboardClassNames.regulatoryHeaderRow}>{headers}</div>
	);
};
